import { SET_CAPTCHA_RESPONSE } from 'constants/captcha';
import type { PayexThunkAction } from 'store/configureStore';

export const setCaptchaResponse =
  (response: string): PayexThunkAction =>
  dispatch => {
    return dispatch({ type: SET_CAPTCHA_RESPONSE, payload: { response } });
  };
